import { useNavigate } from "react-router-dom";
import { useProfileForm } from "../hooks/complete-profile";
import { useForm } from "react-hook-form";
import { useEffect } from "react";

export default function BusinessDescription() {
  const navigate = useNavigate();
  const { formData, updateForm } = useProfileForm();

  useEffect(() => {
    const disableBack = () => {
      window.history.pushState(null, "", window.location.href);
    };
    window.history.pushState(null, "", window.location.href);
    window.addEventListener("popstate", disableBack);
    return () => {
      window.removeEventListener("popstate", disableBack);
    };
  }, []);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      description: formData.description,
    },
  });

  const onSubmit = (data) => {
    updateForm({ description: data.description });
    navigate("/business/complete-profile/opening-hours");
  };

  return (
    <div className="container section-section">
      {/* <div className="back-button">
        <Link to={"/business/complete-profile"} type="button" className="d-flex align-items-center gap-2">
          <i className="fi-rr-arrow-small-left"></i> <span>Back</span>
        </Link>
      </div> */}
      <div className="with-payment">
        <h2 className="h3-headline text-center mt-5">Business Profile Setup</h2>
        <div className="business-profile-wrapper">
          <h4 className="h4-headline text-center">Add your Business Description</h4>

          <form onSubmit={handleSubmit(onSubmit)} style={{ marginTop: "2rem" }}>
            <div className="form-group">
              <label className="form-label subtitle-1" htmlFor="description">
                Business Description <span style={{ color: "red" }}>*</span>
              </label>
              <textarea
                id="description"
                {...register("description", {
                  required: "Description is required",
                  minLength: { value: 20, message: "Minimum 20 characters" },
                  maxLength: { value: 350, message: "Maximum 350 characters" },
                  validate: (value) => {
                    if (!value.trim()) return "Description cannot be empty or just spaces";
                    return true;
                  },
                  pattern: {
                    value: /^[a-zA-Z0-9\s:;!?.,'"’-]+$/,
                    message: "Only letters, numbers, and common punctuation are allowed",
                  },

                  onChange: (e) => updateForm?.({ description: e.target.value }),
                })}
                className="form-control mw-100"
                rows={5}
                placeholder="Enter the name of your business."
              />
              {errors.description && <p className="text-danger mt-1">{errors.description.message}</p>}
            </div>

            <div className="text-center mt-5">
              <button type="submit" className="btn btn-oring px-5">
                Continue
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
